import React from "react";
import { Link } from "react-router-dom";
import { siteConfig } from "../Datas/productData";
import "../css/privacy.scss";

function Faqs() {
  const { contact } = siteConfig;
  const questions = [
    ["orders", "Can I change an order?", "This demonstration does not create real orders. On a live store, contact us as soon as possible; changes cannot be guaranteed after preparation begins."],
    ["sizing", "How do I choose a size?", "Use the fit note and available sizes on each product page. For personal guidance, email our client service team before ordering."],
    ["delivery", "Where do you deliver?", "Destinations, estimated transit times and charges are shown in our shipping information and should be confirmed again at checkout."],
    ["returns", "What is the return window?", "Eligible unworn items may be returned within 30 days of delivery, subject to the conditions in our returns policy."],
    ["materials", "Are colours and materials exact?", "We photograph and describe products carefully, but screens and the natural variation of leather, suede, denim and knitwear can create small differences."],
    ["privacy", "How is my information used?", "Only information needed for the stated shopping, support, security and communication purposes should be collected. See our privacy and cookie policies for details."],
  ];

  return (
    <main className="privacy" id="main-content" tabIndex="-1">
      <header className="privacy__header">
        <p>Information / 01</p>
        <h1>Frequently<br />asked questions</h1>
        <div><span>Contact</span><a href={`mailto:${contact.email}`}>{contact.email}</a></div>
      </header>
      <div className="privacy__layout">
        <nav className="privacy__nav" aria-label="FAQ sections">
          <p>On this page</p>
          <ol>{questions.map(([id, question], index) => <li key={id}><a href={`#faq-${id}`}><span>{String(index + 1).padStart(2, "0")}</span>{question}</a></li>)}</ol>
        </nav>
        <article className="privacy__article">
          {questions.map(([id, question, answer], index) => (
            <section id={`faq-${id}`} key={id}>
              <p className="privacy__section-number">{String(index + 1).padStart(2, "0")} / FAQ</p>
              <h2>{question}</h2>
              <p>{answer}</p>
            </section>
          ))}
          <section>
            <h2>Still need help?</h2>
            <p>Email <a href={`mailto:${contact.email}`}>{contact.email}</a>, or review our <Link to="/shipping">shipping</Link> and <Link to="/returns">returns</Link> information.</p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Faqs;
